"use strict";

Messages.FormView = class FormView {
  constructor(data, success) {
    this.data = data;
    this.success = success;
    this.placeholder = this.data.placeholder || "Write a message";
  }
  render() {
    return JST["messages/templates/form"](this.data);
  }
  after_render(container) {
    const form = container.find(".new_message");
    const button = form.find(".submit-reply-button");
    const body = form.find("textarea");
    const errorText = form.find(".js-error-text");
    body.attr("placeholder", this.placeholder);
    body.autosize({
      callback() {
        form.trigger("resize_modal");
      }
    });
    if (!this.data.message_thread_id) {
      new Messages.RecipientFinder(form.find(".recipient-input"));
    }
    button.on("click", e => {
      e.preventDefault();
      errorText.text("");
      button.button("loading");
      Messages.send_message({
        data: form.serialize()
      }).always(() => {
        button.button("reset");
      }).done(function () {
        var _a;
        (_a = this.success) == null ? void 0 : _a.call(this, ...arguments);
      }.bind(this)).error(xhr => {
        let errorMessage = "Sorry, an error occurred. Please try again.";
        if (xhr.status === 422) {
          try {
            const response = JSON.parse(xhr.responseText);
            const errors = Object.values(response.errors).flat();
            if (errors[0]) {
              errorMessage = errors[0];
            }
          } catch (error) {}
        }
        errorText.text(errorMessage);
      });
    });
  }
};